import { useQuery } from '@tanstack/react-query';
import { type AdviceDto } from '../types';

export function useFilesWithAdvice(fileIds: string[]) {
  const { data, isLoading } = useQuery<AdviceDto[]>({
    queryKey: ['advice', { fileIds: fileIds.join(',') }],
    enabled: fileIds.length > 0,
  });

  const fileIdsWithAdvice = new Set<string>();
  if (data) {
    for (const advice of data) {
      if (advice.adviceClass !== 'NO_ADVICE_DETECTED' && advice.dataUploadFileId) {
        fileIdsWithAdvice.add(advice.dataUploadFileId);
      }
    }
  }

  return { fileIdsWithAdvice, isLoading: fileIds.length > 0 && isLoading };
}
